// src/utils/adaptText.js
//
// Sport → corporate PHRASE adapter for content authored in sport voice
// (squad playbooks, action-plan copy). Labels and nav copy live in
// data/copyDictionary.js; worksheet content uses inline {sport|corporate}
// tokens (utils/worksheetVoice.js). Reach it through hooks/useOrgVoice.js.
//
// "practice" is only translated where it is the sport NOUN (team practice,
// pre-/post-practice, at/after/before practice). The verb — "practice
// mindfulness daily", "practice it until it's automatic" — is left alone;
// the earlier blanket rewrite produced "workday mindfulness daily".

const RULES = [
    [/\bPre-Practice\b/g, 'Morning Kickoff'],
    [/\bpre-practice\b/g, 'morning kickoff'],
    [/\bPre Practice\b/g, 'Morning Kickoff'],
    [/\bpre practice\b/g, 'morning kickoff'],
    [/\bDuring Practice\b/g, 'During the Workday'],
    [/\bduring practice\b/g, 'during the workday'],
    [/\bPost-Practice\b/g, 'End of Day'],
    [/\bpost-practice\b/g, 'end of day'],
    [/\bPost Practice\b/g, 'End of Day'],
    [/\bpost practice\b/g, 'end of day'],
    [/\bTeam Practice\b/g, 'Team Meeting'],
    [/\bteam practice\b/g, 'team meeting'],
    [/\b(at|after|before) practice\b/g, '$1 work'],
    [/\bpractice sessions?\b/g, 'work sessions'],
    [/\bPractice Plan\b/g, 'Work Plan'],
    [/\bpractice plan\b/g, 'work plan'],
    [/\bAthletes\b/g, 'Employees'],
    [/\bathletes\b/g, 'employees'],
    [/\bAthlete\b/g, 'Employee'],
    [/\bathlete\b/g, 'employee'],
    [/\bPlayers\b/g, 'Team Members'],
    [/\bplayers\b/g, 'team members'],
    [/\bPlayer\b/g, 'Team Member'],
    [/\bplayer\b/g, 'team member'],
    [/\bCoaches\b/g, 'Managers'],
    [/\bcoaches\b/g, 'managers'],
    [/\bCoach\b/g, 'Manager'],
    [/\bcoach\b/g, 'manager'],
    [/\bTeammates\b/g, 'Colleagues'],
    [/\bteammates\b/g, 'colleagues'],
    [/\bTeammate\b/g, 'Colleague'],
    [/\bteammate\b/g, 'colleague'],
    [/\bSquad\b/g, 'Team'],
    [/\bsquad\b/g, 'team']
];

export const adaptCorporateText = (text, isCorporate) => {
    if (!isCorporate || typeof text !== 'string') return text;
    return RULES.reduce((out, [re, to]) => out.replace(re, to), text);
};
